// extracted by mini-css-extract-plugin
export default {"PlainFeature":"vy_a bhe_b"};